// src/useMeta.js
// Sets page-specific <title>, <meta name="description">, and <link rel="canonical">
import { useEffect } from 'react';

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(url) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', url);
}

export function useMeta({ title, description, canonical }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta('description', description);
    if (canonical) setCanonical(canonical);
  }, [title, description, canonical]);
}
